import { render, staticRenderFns } from "./TheDebtorPropertyModal.vue?vue&type=template&id=0aeaf242&"
import script from "./TheDebtorPropertyModal.vue?vue&type=script&lang=js&"
export * from "./TheDebtorPropertyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports